import classnames from 'classnames';

export const SeeDetails = props => {
  const {
    selectedPotentialFactor,
    handleClickInFactor,
    seenOfferModulePosition,
    ctaText,
  } = props;
  const cta = ctaText ? ctaText : 'See details.';

  const handleEnterKeyPress = (
    event,
    selectedPotentialFactor,
    seenOfferModulePosition,
  ) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleClickInFactor(selectedPotentialFactor, seenOfferModulePosition);
    }
  };

  return (
    <div
      className={'margT10 system_info_i300_text pointer text-underline'}
      onClick={() => {
        handleClickInFactor(selectedPotentialFactor, seenOfferModulePosition);
      }}
      tabIndex={'0'}
      onKeyDown={e =>
        handleEnterKeyPress(e, selectedPotentialFactor, seenOfferModulePosition)
      }
      role="link"
    >
      {cta}
    </div>
  );
};

export const BureauReport = props => {
  const { handleClickBereauReport } = props;
  return (
    <div
      className={'inline system_info_i300_text pointer text-underline'}
      onClick={() => {
        handleClickBereauReport();
      }}
    >
      3-bureau report
    </div>
  );
};

export const OpeningNewCreditCard = props => {
  const { noCreditUsage, handleClickOpeningNewCreditCard, isNoLink } = props;
  const wrapClasses = classnames('inline', {
    'system_info_i300_text pointer text-underline': !isNoLink,
  });
  return (
    <div
      className={`inline ${wrapClasses}`}
      onClick={() => {
        handleClickOpeningNewCreditCard();
      }}
    >
      {`${noCreditUsage ? 'get ' : 'opening '} a new credit card`}
    </div>
  );
};

export const GettingNewCard = props => {
  const { handleClickGettingNewCard, ctaText, isNoLink } = props;
  const wrapClasses = classnames('inline', {
    'system_info_i300_text pointer text-underline': !isNoLink,
  });
  return (
    <div
      className={wrapClasses}
      onClick={() => {
        handleClickGettingNewCard();
      }}
    >
      {ctaText ? ctaText : 'getting a new card'}
    </div>
  );
};

export const OpenAccountToday = props => {
  const { handleClickOpenAccountToday } = props;
  return (
    <div
      className={'inline system_info_i300_text pointer text-underline'}
      onClick={() => {
        handleClickOpenAccountToday();
      }}
    >
      Open an account today
    </div>
  );
};

export const ExploreAllPremiumBenefits = props => {
  const {
    selectedPotentialFactor,
    seenOfferModulePosition,
    handleClickExploreAllPremiumBenefits,
  } = props;
  return (
    <div
      className={'inline system_info_i300_text pointer text-underline'}
      onClick={() => {
        handleClickExploreAllPremiumBenefits(
          seenOfferModulePosition,
          selectedPotentialFactor,
        );
      }}
    >
      Explore all premium benefits
    </div>
  );
};
